.ugc-button {
  width: 100%;
  text-align: center;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  outline: none;
  background: none;
  padding: 1px 8px;
  cursor: pointer;
  transition: all linear 0.2s;
  &.primary-disabled {
    color: var(--gray-white);
    background: var(--gray-400);
    border: none;
    cursor: default;
  }
  &.danger-disabled {
    color: var(--gray-white);
    background: var(--gray-400);
    border: none;
    cursor: default;
  }
  &.ghost-disabled {
    color: var(--gray-white);
    background: var(--gray-400);
    border: 1px solid var(--gray-400);
    cursor: default;
    &:hover {
      background: var(--gray-400);
    }
  }
  &.text-disabled {
    background: none;
    border: none;
    cursor: default;
    &:hover {
      background: none;
    }
  }
}

.ugc-button-primary {
  color: var(--gray-white);
  background: var(--green-dark);
  &:hover {
    opacity: 0.9;
  }
}

.ugc-button-ghost {
  color: var(--gray-700);
  border: 1px solid var(--gray-400);
  background: var(--gray-white);
  &:hover {
    background: var(--gray-200);
  }
}

.ugc-button-danger {
  color: var(--gray-white);
  background: var(--red-standard);
  &:hover {
    opacity: 0.9;
  }
}

.ugc-button-text {
  &:hover {
    background: var(--gray-200);
    border-radius: 12px;
  }
}
